<template>
  <div v-if="data" class="ebook-info-page">
    <div class="ebook-info-page-body">
      <div class="ebook-info-page-body-top flex">
        <div v-if="data.coverImg" class="ebook-info-page-body-top-img flex-shrink" :style="{backgroundImage: 'url(' + data.coverImg + ')'}" />
        <div v-else class="ebook-info-page-body-top-img flex-shrink default-img-cover" />
        <div class="ebook-info-page-body-top-tit flex-1">
          <p class="font-24 tit">{{ data.bookName }}</p>
          <span v-if="data.author" class="item flex">
            <p class="font-14 key flex-shrink">著者：</p>
            <p class="font-14 value flex-1">{{ data.author }}</p>
          </span>
          <span v-if="data.press" class="item flex">
            <p class="font-14 key flex-shrink">出版社：</p>
            <p class="font-14 value flex-1">{{ data.press }}</p>
          </span>
          <span v-if="data.edition" class="item flex">
            <p class="font-14 key flex-shrink">版次：</p>
            <p class="font-14 value flex-1">{{ data.edition }}</p>
          </span>
          <span v-if="data.isbn" class="item flex">
            <p class="font-14 key flex-shrink">ISBN：</p>
            <p class="font-14 value flex-1">{{ data.isbn }}</p>
          </span>
          <span v-if="data.publicationTime" class="item flex">
            <p class="font-14 key flex-shrink">出版时间：</p>
            <p class="font-14 value flex-1">{{ data.publicationTime }}</p>
          </span>
          <span v-if="data.pdf" class="read-btn">
            <p class="font-color-fff font-14 cursor" @click="toRead">在线阅读</p>
          </span>
        </div>
      </div>
      <div v-if="data.pdf" class="ebook-info-page-body-files">
        <div class="ebook-info-page-body-files-head flex-row-center">
          <p class="line" />
          <p class="font-16 font-bold">电子书</p>
        </div>
        <div class="ebook-info-page-body-files-list flex">
          <div class="item flex-row-center-between">
            <span class="flex-row-center flex-1">
              <img src="@/assets/img/icon-source-pdf.png">
              <p class="font-14 tit text-line-1">{{ getFileName(data.pdf) }}</p>
            </span>
            <p class="font-12 cursor btn flex-shrink" @click="downFile">下载</p>
          </div>
        </div>
      </div>
      <div v-if="data.introduction" class="ebook-info-page-body-des">
        <div class="ebook-info-page-body-files-head flex-row-center">
          <p class="line" />
          <p class="font-16 font-bold">书籍介绍</p>
        </div>
        <div class="ebook-info-page-body-des-text">
          <p class="font-16" v-html="data.introduction" />
        </div>
      </div>
      <div v-if="nextBook" class="ebook-info-page-body-bottom flex-row-center">
        <p class="font-14" @click="toNext">下一篇：{{ nextBook.bookName }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import FileSaver from 'file-saver'
import { getShowPath } from '@/utils/imgpath.js'
export default {
  data() {
    return {
      nextBook: null,
      curIndex: 0,
      data: null,
      list: []
    }
  },
  methods: {
    showInfo(curData, index, list) {
      this.data = curData
      this.list = list
      if (index + 1 < list.length) {
        this.nextBook = list[index + 1]
        this.curIndex = index
      } else {
        this.nextBook = null
      }
    },
    getFileName(str) {
      return str.split('/').pop()
    },
    downFile() {
      const url = getShowPath('pdf', this.data.pdf)
      FileSaver.saveAs(url, this.data.bookName)
    },
    toRead() {
      const url = getShowPath('pdf', this.data.pdf)
      window.open(url)
    },
    toNext() {
      this.curIndex += 1
      if (this.curIndex + 1 < this.list.length) {
        this.nextBook = this.list[this.curIndex + 1]
      } else {
        this.nextBook = null
      }
      this.data = this.list[this.curIndex]
    }
  }
}
</script>

<style>

.ebook-info-page {
  padding: 20px 0 60px;
}

.ebook-info-page-body-top {
  margin-bottom: 30px;
}

.ebook-info-page-body-top-img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 210px;
  height: 300px;
  margin-right: 20px;
  border-radius: 3px;
}

.ebook-info-page-body-top-tit .tit {
  color: #1A1A1A;
  line-height: 36px;
  margin-bottom: 10px;
}

.ebook-info-page-body-top-tit .item .key {
  width: 80px;
  line-height: 32px;
  color: #767676;
}

.ebook-info-page-body-top-tit .item .value {
  line-height: 32px;
  color: #1A1A1A;
}

.ebook-info-page-body-top-tit .read-btn p {
  line-height: 40px;
  width: 120px;
  text-align: center;
  background: #B21F12;
  border-radius: 3px;
  margin-top: 20px;
}

.ebook-info-page-body-files {
  margin-bottom: 30px;
}

.ebook-info-page-body-files-head {
  height: 50px;
}

.ebook-info-page-body-files-head .line {
  background: #B21F12;
  width: 4px;
  height: 16px;
  margin-right: 6px;
}

.ebook-info-page-body-files-head p {
  color: #B21F12;
}

.ebook-info-page-body-files-list {
  flex-wrap: wrap;
}

.ebook-info-page-body-files-list .item {
  width: calc(50% - 5px);
  height: 40px;
  border-radius: 5px;
  background: #F7F7F7;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 15px;
}

.ebook-info-page-body-files-list .item:nth-child(2n) {
  margin-right: 0;
}

.ebook-info-page-body-files-list .item img {
  margin-right: 10px;
}

.ebook-info-page-body-files-list .item .tit {
  color: #1A1A1A;
}

.ebook-info-page-body-files-list .item .btn {
  color: #767676;
  margin-left: 10px;
}

.ebook-info-page-body-des-text p{
  line-height: 32px;
  color: #1A1A1A;
}

.ebook-info-page-body-bottom {
  margin-top: 60px;
  border-top: 1px solid #eee;
  height: 50px;
}

.ebook-info-page-body-bottom p {
  color: #1A1A1A;
}

</style>
